var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","border":"1px solid #dedede","height":"50px","font-family":"cursive"}},[_vm._v(" Max Mustermann ")])}
var staticRenderFns = []

export { render, staticRenderFns }